import { cn } from '@/lib/utils'
import { INVOICE_STATUS_LABELS, INVOICE_STATUS_STYLES } from '@/lib/invoice'
import type { InvoiceStatus } from '@/api/types'

const badgeBaseClass = 'inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium'

export function InvoiceStatusBadge({ status }: { status: InvoiceStatus }): React.ReactElement {
  return <span className={cn(badgeBaseClass, INVOICE_STATUS_STYLES[status])}>{INVOICE_STATUS_LABELS[status]}</span>
}
